export const theme = {
  'default': {
    primary: '#26304d',
    primary2: '#44537e',
    secondary: '#a61d37',
    background: '#f5f6fa',
    testimonialBullet: '#ffffff',
    testimonialBulletActive: '#000000',
  },
  'rebrand': {
    primary: '#000000',
    primary2: '#000000',
    secondary: '#a6a6a6',
    background: '#f5f6fa',
    testimonialBullet: '#666666',
    testimonialBulletActive: '#ffffff'
  }
}


// WEBPACK FOOTER //
// ./src/theme.js